export default "__VITE_ASSET__LRSLb$x5__"